import React, { Component } from "react";
import { connect } from "react-redux";
import Storage from "../../../../helpers/Storage";
import DatePicker from "../../../../shared/component/DatePicker/DatePicker";
import "./Navbar.scss";
import Config from "../../../../config";
import NavbarPart1 from "./NavbarPart1/NavbarPart1";

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      patterns: [],
      showPopover: false,
      language: Storage.getLanguage(),
      selectedDate: Config.daysBeforePanel
    };
  }

  UNSAFE_componentWillMount() {
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.language !== this.props.language) {
        this.setState({language: this.props.language});
    }
    if (prevProps.device !== this.props.device) {
        this.setState({device: this.props.device});
    }
  }

  componentWillUnmount() {
  }

  // Private methods
  #stateSetter = (newState = {}, callBackFn = () => {}) => {
    this.setState({
      ...newState
    }, callBackFn);
  }

  handleDateChange = (value) => {
    // this.setState({
    //   selectedDate: value
    // },() => {
    //   eventBus.dispatchEvent("filterByDate", this.state.selectedDate);
    // });
  }

  handlePatterns = () => {
    if (!this.state.patterns.length) {
      this.setState({
        showPopover: true
      });
    }
  }

  closeAddNewPatternPopover = () => {
    this.setState({
      showPopover: false
    });
  }

  render() {

    return <nav>
      <div className="navbar__container">
        <div className="column-1">
          {/* <Label labelText="patterns" color="gray" />
          <div className="popups__wrapper">
            <Button size="small" buttonText="manage_patterns" mode="gray" onClick={this.handlePatterns} />
            {
              this.state.showPopover && 
              <Popover closePopover={this.closeAddNewPatternPopover}>
                <p>
                  <T token="no_pattern" />
                </p>
                <p>
                  <T token="add_pattern_msg" />
                </p>
                <Button size="small" buttonText="add_new_pattern" mode="warning" />
              </Popover>
            }
          </div> */}

          <NavbarPart1 />

        </div>

        <div className="column-2">
          <DatePicker type="full" onDateChanged={this.handleDateChange} />
        </div>
      </div>
    </nav>
  }
}

const mapStateToProps = state => {
  const language = state.LangReducer.language;
  const device = state.DeviceModeReducer.mode;
  return {language, device};
};

export default connect(mapStateToProps)(Navbar);
